import React, { useEffect } from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import * as Styled from '../../steps/styled';
import { constants, storage } from 'utils';

import bannerImg from 'assets/disability.png';

const TechnicalError: React.FC = () => {
  useEffect(() => {
    storage.clear();
  }, []);

  return (
    <Page
      title={constants.Page.title}
      showFooter={true}
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}>
      <Styled.Wrapper>
        <Styled.HeadingWrapper>
          <Text.Heading.H1 fontWeight='bold'>Technical Error</Text.Heading.H1>
          <Styled.Spacer24 />
        </Styled.HeadingWrapper>
        <Styled.Spacer24 />
        <Text.Body>
          Or tap &lsquo;Contact us&rsquo; to leave your details and we’ll get back to you.
        </Text.Body>
        <Styled.Spacer24 />
        <Text.Link
          target='_blank'
          value='Contact us'
          href='https://service.vic.gov.au/contact/send-us-a-message'
        />
      </Styled.Wrapper>
    </Page>
  );
};

export default TechnicalError;
